module.exports = __webpack_public_path__ + "07cd8fc861be9a225edf6eaea2b04085.svg";